module.exports = __webpack_public_path__ + "img/society-hypatia-avatar.ca2149ea.png";